/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const cloud_transfer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#cloud_transfer_svg__a)">
      <path
        fill="#000"
        d="m3.559 4.83.139.737-.14-.737Zm8.728 1.211-.742-.11a.75.75 0 0 0 .8.858l-.058-.748Zm-6.942-.194a.75.75 0 0 0 .748-1.3l-.748 1.3Zm-.859 8.996a.75.75 0 0 0 1.5 0h-1.5Zm2.107-2.93a.75.75 0 0 0 1.061-1.061l-1.06 1.06Zm-1.357-2.42.53-.53a.75.75 0 0 0-1.06 0l.53.53Zm-2.418 1.358a.75.75 0 0 0 1.06 1.06l-1.06-1.06Zm8.509-1.358a.75.75 0 0 0-1.5 0h1.5Zm-2.107 2.93a.75.75 0 1 0-1.061 1.061l1.06-1.06Zm1.357 2.419-.53.53a.75.75 0 0 0 1.06 0l-.53-.53Zm2.418-1.358a.75.75 0 0 0-1.06-1.06l1.06 1.06ZM.772 9.87a.75.75 0 1 0 1.298-.751l-1.298.75Zm12.776.091a.75.75 0 1 0 .905 1.196l-.905-1.196ZM1.75 7.921c0-1.17.839-2.145 1.948-2.354l-.279-1.474A3.897 3.897 0 0 0 .25 7.921h1.5Zm2.554-3.006C4.527 2.97 6.268 1.75 7.92 1.75V.25c-2.29 0-4.784 1.675-5.106 4.495l1.49.17ZM7.92 1.75c2.417 0 3.92 2.18 3.624 4.182l1.484.219C13.44 3.356 11.364.25 7.92.25v1.5Zm4.423 5.039c1.006-.078 1.906.752 1.906 1.762h1.5c0-1.888-1.648-3.402-3.521-3.258l.115 1.496ZM3.698 5.567a2.428 2.428 0 0 1 1.647.28l.748-1.3a3.928 3.928 0 0 0-2.674-.454l.279 1.474Zm3.956 5.285L5.766 8.964l-1.06 1.06 1.887 1.888 1.061-1.06ZM4.706 8.964l-1.888 1.888 1.06 1.06 1.888-1.887-1.06-1.061Zm3.453 4.521 1.888 1.888 1.06-1.06-1.887-1.888-1.061 1.06Zm2.948 1.888 1.888-1.888-1.06-1.06-1.888 1.887 1.06 1.061Zm-1.28-5.879v5.349h1.5V9.494h-1.5Zm-3.84 5.349V9.494h-1.5v5.349h1.5ZM2.07 9.119a2.382 2.382 0 0 1-.32-1.198H.25c0 .709.19 1.375.522 1.949l1.298-.751Zm12.18-.568c0 .575-.274 1.086-.702 1.41l.905 1.196a3.263 3.263 0 0 0 1.297-2.606h-1.5Z"
      />
    </g>
    <defs>
      <clipPath id="cloud_transfer_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default cloud_transfer
